import React, {useEffect} from 'react';
import Logo from "img/logo";
import {useAuthContext} from "v4/contexts/AuthContext";
import {useHistory} from "react-router-dom";
import UserService from "api/user/user";
import useNotification from "v4/hooks/useNotification";
import {useTranslation} from "react-i18next";

export default function AuthenticationChecker({children}) {
    const {t} = useTranslation();
    const {token, user, setToken, logOut} = useAuthContext();
    const {addErrorNotification} = useNotification();
    const {replace} = useHistory();

    // If there is a token but no user, we set the token again to trigger the user fetch
    useEffect(() => {
        if (user || !token) return;

        setToken(token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const redirectTo = UserService.getRedirectTo();

        if (!token || !user || !redirectTo) return;

        UserService.removeRedirectTo(); // Clear redirectTo after using it

        const urlRedirectTo = redirectTo?.startsWith('http') ? new URL(redirectTo) : new URL(redirectTo ?? '/', window.location.origin);

        if (urlRedirectTo.origin !== window.location.origin) {
            window.location.href = urlRedirectTo.href;
            return;
        }

        replace({
            pathname: urlRedirectTo.pathname,
            search: urlRedirectTo.search,
        });
    }, [token, user, replace]);

    // Check token validity on mount
    useEffect(() => {
        if (!token || !UserService.isTokenExpired()) return;

        if (UserService.getTokenData() && UserService.isTokenExpired()) {
            addErrorNotification(t('expired_token'));
        }

        logOut();
    }, [addErrorNotification, logOut, t, token]);

    if (token && !user) {
        return (
            <main className="loginpage">
                <div className="login__loader">
                    <div className="login__loader__logo">
                        <Logo/>
                    </div>
                </div>
            </main>
        )
    }

    return children;
}
